import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../../components/Navbar";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import EmailEditor from "react-email-editor";
import { TextField, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import {
  getEmailTemplateDesignByID,
  updateEmailTemplateDesign,
  createEmailTemplateDesign,
} from "./Helper";

const EmailTemplateDesign = () => {
  const context = useOutletContext();
  const location = useLocation();
  const emailEditorRef = useRef(null);
  const navigate = useNavigate();
  const designId = location.state?.id;
  const isNew = location.state?.isNew;
  const [hasContent, setHasContent] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: location.state?.name,
    },
  });

  const onReady = () => {
    if (designId) {
      // Load existing design
      getEmailTemplateDesignByID(designId)
        .then((res) => {
          console.log("API Response:", res.data);
          // Handle different response structures
          let designData = null;
          
          if (res.data?.emailTemplateDesign) {
            // If it's an array, get the first item
            if (Array.isArray(res.data.emailTemplateDesign)) {
              designData = res.data.emailTemplateDesign[0];
            } else {
              // If it's a single object
              designData = res.data.emailTemplateDesign;
            }
          } else if (res.data) {
            // Direct object response
            designData = res.data;
          }
          
          console.log("Design Data:", designData);
          
          if (designData?.json_content && designData.json_content.trim() !== "") {
            try {
              const parsedDesign = JSON.parse(designData.json_content);
              console.log("Parsed Design:", parsedDesign);
              
              // Ensure editor is ready
              if (emailEditorRef.current?.editor) {
                emailEditorRef.current.editor.loadDesign(parsedDesign);
                setHasContent(true);
              } else {
                // If editor not ready, try again after a short delay
                setTimeout(() => {
                  if (emailEditorRef.current?.editor) {
                    emailEditorRef.current.editor.loadDesign(parsedDesign);
                    setHasContent(true);
                  }
                }, 500);
              }
            } catch (e) {
              console.error("Error parsing JSON content:", e);
              setHasContent(false);
            }
          } else {
            console.log("No json_content found or empty");
            setHasContent(false);
          }
        })
        .catch((err) => {
          console.error("Error loading design:", err);
          setHasContent(false);
        });
    } else {
      // New design - no content to load
      console.log("New design - no content to load");
      setHasContent(false);
    }
  };

  useEffect(() => {
    const designName = location.state?.name || "Template Design";
    context(["Email Templates", designName]);
  }, []);

  const submit = (formData) => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { design, html } = data;
      console.log(data);
      
      if (isNew && !designId) {
        // Create new design
        createEmailTemplateDesign({
          content: html,
          json_content: JSON.stringify(design),
          name: formData.name || "",
        })
          .then((res) => {
            console.log(res.data);
            navigate("/EmailTemplates/Templates/DesignList");
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (designId) {
        // Update existing design
        updateEmailTemplateDesign({
          id: designId,
          json_content: JSON.stringify(design),
          content: html,
          name: formData.name || location.state?.name || "",
        })
          .then((res) => {
            console.log(res.data);
            navigate("/EmailTemplates/Templates/DesignList");
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.error("No design ID available and not a new design");
      }
    });
  };
  
  const showCreateButton = (isNew && !hasContent) || (!designId && !hasContent);
  const showSaveButton = hasContent && designId;

  return (
    <div className="p-5 shadow-md bg-white">
      <form onSubmit={handleSubmit((data) => submit(data))}>
        <div className="flex justify-between items-center mb-4">
          <h3
            className="text-lg uppercase tracking-wider font-bold"
            style={{ color: "#2EBAA3" }}
          >
            {location.state?.name || "Template Design"}
          </h3>
          <div className="flex items-center gap-4">
            {showCreateButton && (
              <div className="w-80">
                <TextField
                  id="template-name"
                  {...register("name", { required: true })}
                  label="Template Name *"
                  margin="dense"
                  variant="outlined"
                  size="small"
                  fullWidth
                />
                {errors.name && (
                  <p className="text-red-500 text-xs mt-1">Template name is required</p>
                )}
              </div>
            )}
            {(showCreateButton || showSaveButton) && (
              <Button
                type="submit"
                variant="contained"
                style={{ color: "white" }}
              >
                {showCreateButton ? "Create Template Design" : "Save Template Design"}
              </Button>
            )}
          </div>
        </div>
        <div class="overflow-x-auto relative ">
          <EmailEditor
            style={{ height: "100vh" }}
            ref={emailEditorRef}
            onReady={onReady}
          />
        </div>
      </form>
    </div>
  );
};

export default EmailTemplateDesign;
